{
  "name": "06  nuke",
  "title": "TheNuke",
  "description": "TheNukeDescription",
  "stat": 10,
  "boughtEarlyStat": 53,
  "inventoryStat": 18,
  "lockFlag": 15
}